import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import { useEffect, useRef, useState } from 'react';
import {
  getBuildings,
  getGeojsonData,
  getLandmark,
  getLandmarksBySearch,
  getPathMaster,
  saveLandmark,
  savePolygonGlobal,
  uploadFile,
  uploadMedia
} from '../../services/api';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
  CircularProgress,
  Paper,
  Button,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  styled
} from '@mui/material'
import QrScanner from './components/QRScanner';
// import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
// import MapIcon from "@mui/icons-material/Map";

const baseUrl = process.env.NODE_ENV === "development" ? process.env.REACT_APP_LOCAL_URL : process.env.REACT_APP_REMOTE_URL


mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
let globalMarker

function distance(p1, p2) {
  const R = 6371000; // earth radius in meters
  const toRad = deg => deg * Math.PI / 180;

  const dLat = toRad(p2.lat - p1.lat);
  const dLng = toRad(p2.lng - p1.lng);

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(p1.lat)) * Math.cos(toRad(p2.lat)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // meters
}

let initialData = {
  name: "",
  _id: "",
  building_ID: "",
  properties: {
    doorNameLong: "",
    email: "",
    contactNo: "",
    url: "",
    fillColor: "",
    strokeColor: "",
    media: []
  }
}

const FilterPaper = styled(Paper)(({ theme }) => ({
  position: "absolute",
  top: 16,
  right: 0,

  display: "flex",
  flexDirection: "column",
  borderRadius: 2,
  p: 1.5, // padding inside
  zIndex: 20,
  minWidth: 180,
  [theme.breakpoints.down("sm")]: {
    top: 60,
    right: 'unset',
    left: 10
  }
}))

const SearchPaper = styled(Paper)({
  position: "absolute",
  top: 10,
  left: 10,
  display: "flex",
  flexDirection: "column",
  borderRadius: 2,
  overflow: "hidden",
  zIndex: 20
})

const LandmarkPaper = styled(Paper)(({ theme }) => ({
  position: "absolute",
  bottom: 16,
  left: 16,
  display: "flex",
  gap: 2,
  flexDirection: "column",
  borderRadius: 2,
  overflow: "hidden",
  zIndex: 20,
  padding: "8px 10px", // padding inside card
  minWidth: 220,
  bgcolor: "background.paper",
  [theme.breakpoints.down("sm")]: {
    top: 110,
    bottom: 'unset',
    left: 10
  }
}))

const GeoJsonGlobal = () => {

  const [data, setData] = useState()
  const [buildings, setBuildings] = useState()
  const [campusData, setCampusData] = useState()
  const [loading, setLoading] = useState(false)
  const { venueName } = useParams()
  const mapContainer = useRef(null);
  const mapRef = useRef(null);
  const [path, setPath] = useState()
  const [sourceMarker, setSourceMarker] = useState()
  const [destinationMarker, setDestinationMarker] = useState()
  const [searchResult, setSearchResult] = useState()
  const [selectedLandmark, setSelectedLandmark] = useState()
  const [search, setSearch] = useState("")
  const [openEdit, setOpenEdit] = useState(false)
  const [saving, setSaving] = useState(false)
  const [editData, setEditData] = useState(initialData);
  const [editDataPolygon, setEditDataPolygon] = useState(initialData)
  const [fetchingLmark, setFetchingLmark] = useState(false)
  const [fetching, setFetching] = useState(false)
  const [uploading, setUploading] = useState(false)
  const [filter, setFilter] = useState("")
  const [selectedPolygon, setSelectedPolygon] = useState()
  const [camera, setCamera] = useState(false)
  // const [medias, setMedias] = useState()




  const [searchParams, setSearchParams] = useSearchParams()

  const navigate = useNavigate()

  let floor = parseInt(searchParams.get("floor")) || 0



  const fetchData = async () => {
    setLoading(true)
    let resp = await getGeojsonData(venueName, floor)

    setData(resp?.data?.data?.filter(elm => elm?.properties?.type !== "Section" && elm?.properties?.type !== "Sub Section"))
    resp = await getBuildings(venueName, true)

    setBuildings(resp.data.data)
    resp = await getGeojsonData(resp?.data?.data?.campus?.venueName, floor)
    setCampusData(resp?.data?.data)
    setLoading(false)

  }

  useEffect(() => {
    fetchData()

  }, [floor])

  useEffect(() => {
    let accessToken = searchParams.get("accessToken")
    if (accessToken) {
      localStorage.setItem("accessToken", accessToken)
    }

    return () => {
      if (!localStorage.getItem("refreshToken")) {
        localStorage.clear()
        navigate("/auth/signin")
      }
    }
  }, [])


  let landmarks = data?.filter(elm => elm.geometry.type === "Point")


  let campusCenter = buildings?.campus?.coordinates
    ? [buildings.campus.coordinates[0], buildings.campus.coordinates[1]].reverse()
    : buildings?.buildings?.length > 0 ?
      [buildings?.buildings[0].coordinates[0], buildings?.buildings[0].coordinates[1]].reverse()
      : [0, 0]

  useEffect(() => {
    if (!data || !buildings || !campusData) return; // prevent re-init

    let filteredData = data?.filter(elm => {
      if (elm?.geometry?.type !== "Point") return elm
      if (filter === "") return elm
      else {
        if (elm?.properties?.element?.subType === filter) return elm
        else if (elm?.properties?.type === filter) return elm
      }
    })

    let filteredDataCampus = campusData?.filter(elm => {
      if (elm?.geometry?.type !== "Point") return elm
      if (filter === "") return elm
      else {
        if (elm?.properties?.element?.subType === filter) return elm
        else if (elm?.properties?.type === filter) return elm
      }
    })

    if (mapRef.current && buildings) {
      mapRef.current.remove();   // 🔑 remove old map instance
      mapRef.current = null;
    }

    let lat = parseFloat(searchParams.get("lat"))
    let lng = parseFloat(searchParams.get("lng"))
    let zoom = parseFloat(searchParams.get("zoom")) || 18

    if (lat && lng) campusCenter = [lng, lat]

    // 1. Initialize map
    mapRef.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v12",
      center: campusCenter, // near your data
      zoom: zoom,
      maxPitch: 75,
      minZoom: 14
    });

    // 2. Add navigation controls
    // mapRef.current.addControl(new mapboxgl.NavigationControl());

    // 3. Add source + layers after map loads
    mapRef.current.on("load", () => {
      mapRef.current.addSource("buildings", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [...filteredData, ...filteredDataCampus]
        }
      });

      mapRef.current.on("dragend", () => {

        let center = mapRef?.current?.getCenter()
        setSearchParams(params => {
          params.set("lat", center.lat)
          params.set("lng", center.lng)

          return params
        })
      })

      mapRef.current.on("zoomend", () => {

        let zoom = mapRef?.current?.getZoom()

        setSearchParams(params => {
          params.set("zoom", zoom)

          return params
        })
      })

      // Source marker
      const sourceCoords = [...campusCenter]

      const marker1 = new mapboxgl.Marker({ color: "green", draggable: true })
        .setLngLat(sourceCoords)
        .addTo(mapRef.current);

      marker1.on("dragend", () => {
        const lngLat = marker1.getLngLat();

        let nearestPoint = landmarks
          ?.map(lm => ({
            ...lm,
            dist: distance(
              { lng: lm.geometry.coordinates[0], lat: lm.geometry.coordinates[1] },
              lngLat
            )
          }))
          .sort((a, b) => a.dist - b.dist)[0];



        setSourceMarker({
          actualCoord: {
            lng: lngLat.lng.toFixed(6),
            lat: lngLat.lat.toFixed(6)
          },
          nearestPoint
        });
      })

      // Destination marker (slightly offset from source)
      const destCoords = [...campusCenter].map(elm => parseFloat(elm) - 0.0001)


      const marker2 = new mapboxgl.Marker({ color: "red", draggable: true })
        .setLngLat(destCoords)
        .addTo(mapRef.current);

      marker2.on("dragend", () => {
        const lngLat = marker2.getLngLat();

        let nearestPoint = landmarks
          ?.map(lm => ({
            ...lm,
            dist: distance(
              { lng: lm.geometry.coordinates[0], lat: lm.geometry.coordinates[1] },
              lngLat
            )
          }))
          .sort((a, b) => a.dist - b.dist)[0];



        setDestinationMarker({
          actualCoord: {
            lng: lngLat.lng.toFixed(6),
            lat: lngLat.lat.toFixed(6)
          },
          nearestPoint
        });
      });

      // "fill-color": ["get", "fillColor"],




      // Fill polygons
      mapRef.current.addLayer({
        id: "building-fills",
        type: "fill",
        source: "buildings",
        filter: [
          "all",
          ["==", ["geometry-type"], "Polygon"],
          ["==", ["get", "type"], "Boundary"]
        ],
        paint: {
          "fill-color": [
            "coalesce",
            ["get", "fillColor"],
            "#fff"
          ],
          "fill-opacity": [
            "match",
            ["geometry-type"],
            "LineString", 0, //zero for paths
            1 // half for others
          ],

        }
      })
      mapRef.current.addLayer({
        id: "room-extrusion",
        type: "fill-extrusion",
        source: "buildings",
        filter: [
          "all",
          ["==", ["geometry-type"], "Polygon"],
          ["!=", ["get", "polygonType"], "Boundary"],
          ["!=", ["get", "type"], "Boundary"]
        ],
        paint: {
          "fill-extrusion-color": [
            "coalesce",
            ["get", "fillColor"],
            "#b0b0b0"
          ],

          "fill-extrusion-height": [
            "+",

            [
              "case",

              // If type is Wall or Piller AND height missing
              [
                "all",
                ["in", ["get", "type"], ["literal", ["Wall", "Piller"]]],
                ["!", ["has", "height"]]
              ],
              3,

              // otherwise use provided height
              ["coalesce", ["to-number", ["get", "height"]], 2]
            ],

            [
              "coalesce",
              ["to-number", ["get", "baseHeight"]],
              0
            ]
          ]
          ,

          "fill-extrusion-base": [
            "coalesce",
            ["to-number", ["get", "baseHeight"]],
            0
          ],

          "fill-extrusion-opacity": 1
        }
      })




      mapRef.current.on("click", "room-extrusion", async (e) => {
        if (!e.features || !e.features.length) return;

        if (globalMarker) globalMarker.remove()


        const feature = e.features.filter(elm => elm.properties.polygonType === "Room")[0]
        if (feature && !feature?.properties?.global) {
          let lmark = data?.filter(elm => elm.geometry.type === "Point" && elm.properties.polyId === feature?.properties?.nodeId)[0]
          if (lmark) {
            setFetchingLmark(true)
            let response = await getLandmark({ id: lmark?.properties.landmarkId })
            setFetchingLmark(false)
            if (response?.status === 200 && response?.data) {
              globalMarker = new mapboxgl.Marker({ color: "orange" })
                .setLngLat([response?.data?.properties?.longitude, response?.data?.properties?.latitude])
                .addTo(mapRef.current);

              mapRef?.current?.flyTo({
                center: [response?.data?.properties?.longitude, response?.data?.properties?.latitude],
                zoom: 24, // optional: set zoom level
                speed: 1.2, // optional: animation speed
                curve: 1.42, // optional: animation curve
                essential: true
              })

              setSelectedLandmark({ ...response?.data, marker: globalMarker })
            }
            else {
              setSelectedLandmark()
            }


          }
          else {
            setSelectedLandmark()
          }
        }
        else {
          // console.log(e.features)
          let selectedPolygon = e.features.filter(elm => elm?.properties?.polygonType !== "Boundary" && elm?.properties?.type !== "Waypoint")[0]
          if (selectedPolygon) setSelectedPolygon(selectedPolygon)
          else setSelectedPolygon()

          let feature = e.features.filter(elm => elm?.properties?.associatedPoints)[0]
          let elems
          if (feature) elems = JSON.parse(feature?.properties?.associatedPoints)
          else setSelectedPolygon()
          if (elems?.length > 0) {
            setFetchingLmark(true)
            let element = data?.filter(elm => elm.id === elems[0])

            let response = await getLandmark({ id: element[0]?._id })
            setFetchingLmark(false)
            if (response?.status === 200 && response?.data) {
              globalMarker = new mapboxgl.Marker({ color: "orange" })
                .setLngLat(response?.data?.geometry?.coordinates)
                .addTo(mapRef.current);

              mapRef?.current?.flyTo({
                center: response?.data?.geometry?.coordinates,
                zoom: 24, // optional: set zoom level
                speed: 1.2, // optional: animation speed
                curve: 1.42, // optional: animation curve
                essential: true
              })

              setSelectedLandmark({ ...response?.data, name: response?.data?.properties?.name, marker: globalMarker })
            }
            else {
              setSelectedLandmark()
            }
          }
          else {
            setSelectedLandmark()
          }
        }

        // Example: update state

      });

      // Change cursor to pointer on hover
      mapRef.current.on("mouseenter", "building-fills", () => {
        mapRef.current.getCanvas().style.cursor = "pointer";
      });
      mapRef.current.on("mouseleave", "building-fills", () => {
        mapRef.current.getCanvas().style.cursor = "";
      });

      // Borders
      mapRef.current.addLayer({
        id: "building-borders",
        type: "line",
        source: "buildings",
        filter: ["==", ["geometry-type"], "LineString"],
        paint: {
          "line-color": [
            "case",
            ["==", ["geometry-type"], "LineString"], "#f97316", // force orange for LineStrings
            ["has", "strokeColor"], ["get", "strokeColor"],    // use feature property if exists
            "#000"                                             // fallback
          ],
          "line-width": 2
        }
      });


      // Points
      mapRef.current.addLayer({
        id: "landmarks",
        type: "circle",
        source: "buildings",
        paint: {
          "circle-radius": 6,
          "circle-color": [
            "case",
            [
              "any",
              ["==", ["get", "name"], ""],
              ["==", ["get", "type"], ""]
            ],
            "#000000",   // black if name OR type is empty
            "#f97316"    // orange otherwise
          ]
        },
        filter: ["==", "$type", "Point"]
      });



      mapRef.current.on("click", "landmarks", async (e) => {
        if (!e.features || !e.features.length) return;

        if (globalMarker) globalMarker.remove()

        const feature = e.features[0]; // clicked landmark
        // console.log(feature)
        if (feature.properties.polyId) return
        if (feature.properties.landmarkId) {
          setFetchingLmark(true)
          let response = await getLandmark({ id: feature.properties.landmarkId })
          setFetchingLmark(false)
          if (response.status === 200 && response?.data) {
            let center = response?.data?.geometry ? response?.data?.geometry?.coordinates : [response?.data?.properties?.longitude, response?.data?.properties?.latitude]
            globalMarker = new mapboxgl.Marker({ color: "orange" })
              .setLngLat(center)
              .addTo(mapRef.current);

            mapRef?.current?.flyTo({
              center,
              zoom: 24, // optional: set zoom level
              speed: 1.2, // optional: animation speed
              curve: 1.42, // optional: animation curve
              essential: true
            })

            setSelectedLandmark({
              ...response?.data,
              marker: globalMarker,
              name: response?.data?.name || response?.data?.properties?.name,
              floor: response?.data?.floor?.toString() || response?.data?.properties?.level?.toString()
            })
          }
        }

        // Example: update your state

      });

      // Change cursor to pointer on hover
      mapRef.current.on("mouseenter", "landmarks", () => {
        mapRef.current.getCanvas().style.cursor = "pointer";
      });


      if (selectedLandmark) {
        if (globalMarker) globalMarker.remove()
        globalMarker = new mapboxgl.Marker({ color: "orange" })
          .setLngLat([selectedLandmark?.properties?.longitude, selectedLandmark?.properties?.latitude])
          .addTo(mapRef.current);

        mapRef?.current?.flyTo({
          center: [selectedLandmark?.properties?.longitude, selectedLandmark?.properties?.latitude],
          zoom: 24, // optional: set zoom level
          speed: 1.2, // optional: animation speed
          curve: 1.42, // optional: animation curve
          essential: true
        })
      }



    });
  }, [data, buildings, campusData, filter]);






  const findPath = async () => {
    const post = {
      source: {
        latitude: sourceMarker?.actualCoord?.lat,
        longitude: sourceMarker?.actualCoord?.lng,
        level: floor
      },
      destination: {
        latitude: destinationMarker?.actualCoord?.lat,
        longitude: destinationMarker?.actualCoord?.lng,
        level: floor
      }
    }

    let response = await getPathMaster(post)
    setPath(response?.data)
    if (response.status === 200) {
      let path = response?.data
      const features = path?.map((segment, idx) => ({
        type: "Feature",
        properties: {
          id: idx,
          buildingId: segment.buildingId,
          floor: segment.floor,
          distance: segment.properties.totalDistance,
          time: segment.properties.totalTime
        },
        geometry: {
          type: "LineString",
          coordinates: segment.path
        }
      }));


      const routeGeoJson = {
        type: "FeatureCollection",
        features
      };

      if (mapRef.current.getSource("route")) {
        // Update existing source
        mapRef.current.getSource("route").setData(routeGeoJson);
      } else {
        // Add new source + layer
        mapRef.current.addSource("route", {
          type: "geojson",
          data: routeGeoJson
        });

        mapRef.current.addLayer({
          id: "route-line",
          type: "line",
          source: "route",
          layout: {
            "line-join": "round",
            "line-cap": "round"
          },
          paint: {
            "line-color": "#3b82f6", // Tailwind blue-500
            "line-width": 4
          }
        });
      }
    }

  }

  const clearPath = () => {
    if (mapRef.current.getSource("route")) {
      setPath(null); // reset your state (better to pass null than undefined)

      // remove layer before source
      if (mapRef.current.getLayer("route-line")) {
        mapRef.current.removeLayer("route-line");
      }
      mapRef.current.removeSource("route");
    }
  };

  const handleSearch = async (e) => {
    setSearch(e.target.value)
    setFetching(true)
    let response = await getLandmarksBySearch({
      venueName,
      keyword: e.target.value
    })
    setFetching(false)

    // console.log(response?.data)
    setSearchResult(response.data.data)
  }

  const handleSelectLmark = (elm) => {
    setSearch("")
    if (selectedLandmark) {
      selectedLandmark?.marker?.remove()
    }
    if (globalMarker) {
      globalMarker.remove()
    }
    setSearchResult(null)

    let center = elm?.geometry ? elm?.geometry?.coordinates : [elm?.properties?.longitude, elm?.properties?.latitude]
    globalMarker = new mapboxgl.Marker({ color: "orange" })
      .setLngLat(center)
      .addTo(mapRef.current);

    setSelectedLandmark({ ...elm, marker: globalMarker })

    let filteredPolygons = data?.filter(elm => elm.geometry.type === "Polygon" && elm?.associatedPoints?.length > 0)
    // console.log(filteredPolygons[0]?.associatedPoints, elm?.id)
    const selectedPolygon = filteredPolygons?.filter(item => item?.associatedPoints?.includes(elm?.id))[0]
    // console.log(selectedPolygon)
    if (selectedPolygon) setSelectedPolygon(selectedPolygon)
    else setSelectedPolygon()


    if (floor !== elm.floor) {
      setSearchParams(params => {
        params.set("floor", elm.floor)

        return params
      })
    }
    else {
      mapRef?.current?.flyTo({
        center,
        zoom: 24, // optional: set zoom level
        speed: 1.2, // optional: animation speed
        curve: 1.42, // optional: animation curve
        essential: true
      })
    }

  }

  const handleChange = (e) => {
    if (e.target.name === "name" || e.target.name === "priority") setEditData({
      ...editData,
      [e.target.name]: e.target.value
    })
    else {
      setEditData({
        ...editData,
        properties: {
          ...editData.properties,
          [e.target.name]: e.target.value
        }
      })
    }
  }

  const handleChangePolygon = (e) => {
    // console.log(e.target.name, e.target.value)

    setEditDataPolygon({
      ...editDataPolygon,
      properties: {
        ...editDataPolygon.properties,
        [e.target.name]: e.target.value
      }
    })
  }

  const handleSaveData = async () => {
    if (editData?.geometry?.type === "Point") {
      setSaving(true)
      await saveLandmark(editData?._id, { ...editData, marker: null }, setSaving)
      setSaving(false)
      setOpenEdit(false)
      setSelectedLandmark({
        ...editData,
        marker: editData.marker
      })
      fetchData()
      setEditData(initialData)
    }

    if (editData?.element?.type === "Rooms") {
      setSaving(true)
      await saveLandmark(editData?._id, { ...editData, marker: null }, setSaving)
      setSaving(false)
      setOpenEdit(false)
      setSelectedLandmark({
        ...editData,
        marker: editData.marker
      })
      fetchData()
      setEditData(initialData)
    }

    // console.log(editDataPolygon)

    if (editDataPolygon?.layer?.id === "building-fills") {
      setSaving(true)
      let response = await savePolygonGlobal(editDataPolygon?.properties?.landmarkId, {
        name: editDataPolygon?.properties?.name,
        number: editDataPolygon?.properties?.number,
        fillColor: editDataPolygon?.properties?.fillColor,
        strokeColor: editDataPolygon?.properties?.strokeColor,
        imageFile: editData?.properties?.imageFile
      })
      setSaving(false)
      if (response.status === 200) {
        setEditDataPolygon(initialData)
        setSelectedPolygon({
          properties: response?.data?.data?.properties
        })
        setOpenEdit(false)
        fetchData()
      }
    }

  }

  const allInstructions = path?.map(seg => seg.properties.instruction);
  const totals = path?.map(seg => ({
    totalDistance: seg.properties.totalDistance,
    totalTime: seg.properties.totalTime
  }))

  const handleChangeFile = async (event) => {
    const file = event.target.files[0];
    const imageFormData = new FormData();
    imageFormData.append('image', file);

    setUploading(true);
    const response = await uploadFile(imageFormData);
    setUploading(false);

    if (response.data.status) {
      setEditData({
        ...editData,
        properties: {
          ...editData.properties,
          filename: `${baseUrl}/uploads/${response?.data?.filename}`
        }
      });
    }
  };

  const handleChangeMedia = async (event) => {
    const files = event.target.files;
    const mediaFormData = new FormData();

    for (let file of files) {
      mediaFormData.append("media", file); // append one by one
    }

    setUploading(true);
    const response = await uploadMedia(mediaFormData);
    setUploading(false);
    console.log(editData)
    if (response.status === 200) {
      console.log({
        ...editData,
        properties: {
          ...editData.properties,
          media: [...editData.properties.media, ...response?.data?.files]
        }
      })
      setEditData({
        ...editData,
        properties: {
          ...editData.properties,
          media: [...editData.properties.media, ...response?.data?.files]
        }
      });
    }

  };

  const handleRemoveMedia = (mediaItem) => {
    const updated = editData.properties.media.filter(m => m.originalname !== mediaItem.originalname);
    setEditData(prev => ({
      ...prev,
      properties: { ...prev.properties, media: updated }
    }));
  };


  const handleChangeFileRoom = async (event) => {
    const file = event.target.files[0];
    const imageFormData = new FormData();
    imageFormData.append('image', file);

    setUploading(true);
    const response = await uploadFile(imageFormData);
    setUploading(false);

    if (response.data.status) {
      setEditDataPolygon({
        ...editDataPolygon,
        properties: {
          ...editDataPolygon.properties,
          filename: `${baseUrl}/uploads/${response?.data?.filename}`
        }
      });
    }
  };

  let allTypes = new Set()
  data?.forEach(element => {
    if (element?.properties?.element?.subType) allTypes.add(element?.properties?.element?.subType)
    else allTypes.add(element?.properties?.type)
  });
  allTypes = Array.from(allTypes)

  const handleOpenCamera = () => {
    setCamera(true)
  }

  const handleCloseCamera = () => {
    setCamera(false)
  }

  let gpsMarker

  if (navigator.geolocation) {
    navigator.geolocation.watchPosition(
      (position) => {
        const userCoordinates = [position.coords.longitude, position.coords.latitude];

        // Set map center to user's location
        // map.current.setCenter(userCoordinates);

        // Add a marker for the user's location
        if (gpsMarker) gpsMarker.remove()
        gpsMarker = new mapboxgl.Marker({})
          .setLngLat(userCoordinates)
          .setPopup(new mapboxgl.Popup().setText("You are here!")) // Optional popup
          .addTo(mapContainer.current);
      },
      (error) => {
        console.error("Error fetching geolocation:", error.message);
      },
      { enableHighAccuracy: true }
    );
  } else {
    console.error("Geolocation is not supported by this browser.");
  }


  return (
    <div style={{ position: "relative", width: "100%", height: "100vh" }}>
      {/* Map */}
      <div
        ref={mapContainer}
        style={{ width: "100%", height: "100%", borderRadius: "12px" }}
      />

      {/* Overlay loader */}
      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            flexDirection: "column",
            gap: "1rem"
          }}
        >
          <CircularProgress size={48} />
          <p style={{ fontSize: "1.2rem", color: "#333" }}>
            Preparing your map...
          </p>
        </div>
      )}

      {fetchingLmark && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            flexDirection: "column",
            gap: "1rem"
          }}
        >
          <CircularProgress size={48} />
          <p style={{ fontSize: "1.2rem", color: "#333" }}>
            Fetching Landmark...
          </p>
        </div>
      )}

      {/* Floating buttons */}
      <Paper
        elevation={4}
        sx={{
          position: "absolute",
          top: 100,
          right: 16,
          display: "flex",
          flexDirection: "column",
          borderRadius: 2,
          overflow: "hidden",
          zIndex: 20
        }}
      >
        {sourceMarker && (
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>Source:</strong>{" "}
            {`${sourceMarker?.actualCoord?.lng}, ${sourceMarker?.actualCoord?.lat}, ${sourceMarker?.nearestPoint?.properties?.name}`}
          </Typography>
        )}

        {destinationMarker && (
          <Typography variant="body2" sx={{ mb: 2 }}>
            <strong>Destination:</strong>{" "}
            {`${destinationMarker?.actualCoord?.lng}, ${destinationMarker?.actualCoord?.lat}, ${destinationMarker?.nearestPoint?.properties?.name}`}
          </Typography>
        )}

        {sourceMarker && destinationMarker && (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => findPath()}
          >
            Find Path
          </Button>
        )}

        {allInstructions && allInstructions.length > 0 && (
          <div>
            <h3>Instructions</h3>
            <ol>
              {allInstructions?.map((part, idx) => (
                <>
                  {
                    part?.map(ins => (
                      <li key={idx}>
                        {ins?.statement} ({ins?.distance}mtr, {ins.expectedTime?.minutes}min, {ins.expectedTime?.seconds}sec)
                      </li>
                    ))
                  }
                </>
              ))}
            </ol>
          </div>
        )}
        {
          totals?.map(elm => (
            <p>Total :- {elm?.totalDistance}mtr, {elm?.totalTime?.minutes}min, {elm?.totalTime?.seconds}sec</p>
          ))
        }
        {
          path && <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => clearPath()}
          >
            Clear Path
          </Button>
        }
      </Paper>
      <SearchPaper elevation={4}>
        <TextField
          size="small"
          value={search}
          placeholder="Search location..."
          variant="outlined"
          onChange={(e) => handleSearch(e)}

        />
        <div style={{
          maxHeight: "200px",
          overflowY: "auto",
          border: "1px solid #ddd",
          borderRadius: "6px",
          background: "#fff"
        }}>
          {fetching && <CircularProgress size="small" />}
          {searchResult?.map((elm, idx) => (
            <p
              key={idx}
              style={{
                margin: 0,
                padding: "8px 12px",
                cursor: "pointer",
                borderBottom: "1px solid #eee"
              }}
              onClick={() => handleSelectLmark(elm)} // optional
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
            >
              {elm?.name}, {elm?.buildingName}
            </p>
          ))}
        </div>

      </SearchPaper>
      <FilterPaper
        elevation={4}
      >
        <FormControl size="small" fullWidth>
          <InputLabel>Filter</InputLabel>
          <Select
            value={filter}
            label="Filter"
            onChange={(e) => setFilter(e.target.value)}
          >
            <MenuItem value="">All</MenuItem>
            {allTypes?.map(
              (elm, idx) =>
                elm && (
                  <MenuItem key={idx} value={elm}>
                    {elm}
                  </MenuItem>
                )
            )}
          </Select>
        </FormControl>
      </FilterPaper>
      {(selectedLandmark || selectedPolygon) && <LandmarkPaper
        elevation={4}
      >

        {(selectedLandmark || selectedPolygon) && <div
          style={{
            display: "flex",
            gap: "6px",
            alignItems: 'center',
            fontFamily: "sans-serif",
          }}
        >
          <p style={{ margin: 0, fontWeight: 600, fontSize: "16px" }}>
            {selectedLandmark?.name || selectedPolygon?.properties?.name}
          </p>
          <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
            Floor: {selectedLandmark?.floor || selectedLandmark?.properties?.level}
          </p>
          <button
            onClick={() => {
              console.log(selectedLandmark)
              setOpenEdit(true)
              setEditData(selectedLandmark)
              setEditDataPolygon(selectedPolygon)
            }}
            style={{
              alignSelf: "flex-start",
              padding: "6px 12px",
              fontSize: "14px",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#1976d2",
              color: "#fff",
              cursor: "pointer",
              transition: "background 0.2s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#125a9c")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#1976d2")
            }
          >
            Edit
          </button>
          <button
            onClick={() => {
              selectedLandmark?.marker.remove()
              if (globalMarker) globalMarker.remove()
              setSelectedLandmark()
            }}
            style={{
              alignSelf: "flex-start",
              padding: "6px 12px",
              fontSize: "14px",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#dc2626", // red
              color: "#fff",
              cursor: "pointer",
              transition: "background 0.2s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#b91c1c") // darker red on hover
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#dc2626")
            }
          >
            Cancel
          </button>
        </div>}


      </LandmarkPaper>}

      <Paper
        elevation={4}
        sx={{
          position: "absolute",
          bottom: 0,
          right: 0,
          display: "flex",
          flexDirection: "column", // row layout for floor buttons
          gap: 1,
          flexWrap: "wrap", // wrap if too many
          borderRadius: 2,
          overflow: "hidden",
          zIndex: 20,
          p: 2,
          bgcolor: "background.paper"
        }}
      >
        <button onClick={() => {
          navigate("/my-venues")
        }} style={{
          padding: "6px 12px",
          fontSize: "18px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          cursor: "pointer",
          transition: "all 0.2s",
        }}>
          🏠
        </button>
        {buildings?.campus?.totalFloors?.map((elm, idx) => (
          <button
            key={idx}
            onClick={() => {
              setSearchParams(params => {
                params.set("floor", elm)

                return params
              })

            }}
            style={{
              padding: "6px 12px",
              fontSize: "14px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              background: floor == elm ? "#1fc2ad" : "#f3f4f6",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#e5e7eb")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#f3f4f6")
            }
          >

            {elm}
          </button>
        ))}
      </Paper>


      <Dialog
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        maxWidth="sm"
        fullWidth
      >
        {editData && <>
          <DialogTitle>{camera ? editData?.name : "Edit Landmark/Point Details"}</DialogTitle>

          <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>

            {!camera && <TextField label="Door Number" value={editData?.properties?.number} name='number' onChange={handleChange} fullWidth size="small" />}
            {!camera && <TextField label="Door Name" value={editData?.name} name='name' onChange={handleChange} fullWidth size="small" />}

            {editData?.layer?.id === "building-fills" && <>
              <TextField label="Fill Color" type='color' value={editData?.properties?.fillColor} name='fillColor' onChange={handleChange} />
              <TextField label="Stroke Color" type='color' value={editData?.properties?.strokeColor} name='strokeColor' onChange={handleChange} />

            </>}

            {!camera && <>
              {uploading ? <CircularProgress /> : (!editData?.properties?.filename && !editData?.properties?.imageFile) ? <Button
                variant="outlined"
                component="label"
                size="small"
              >
                Upload Icon
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleChangeFile}
                />
              </Button> :
                <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                  <img
                    src={editData?.properties?.filename || editData?.properties?.imageFile}
                    alt="Preview"
                    style={{ width: "100%", maxHeight: 150, objectFit: "contain", borderRadius: 8 }}
                  />
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => {
                      setEditData(prev => ({
                        ...prev,
                        properties: { ...prev.properties, filename: null }
                      }));
                    }}
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      minWidth: "auto",
                      padding: "2px 6px",
                      fontSize: "0.75rem",
                      borderRadius: 4
                    }}
                  >
                    Remove
                  </Button>
                </div>

              }
            </>}

            {/* { console.log(editData?.media) } */}

            {!camera && <Button
              variant="outlined"
              component="label"
              size="small"
            >
              Upload Media
              <input
                type="file"
                accept="image/*, video/*"
                multiple
                hidden
                onChange={handleChangeMedia}
              />
            </Button>}
            {!camera && <Button
              variant="outlined"
              component="label"
              size="small"
              onClick={() => handleOpenCamera()}
            >
              Scan QR
            </Button>}
            {
              camera && <QrScanner
                handleCloseCamera={handleCloseCamera}
                landmarkData={editData}
              />
            }
            {editData?.properties?.media && (
              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "12px",
                  padding: "10px"
                }}
              >
                {editData?.properties?.media && (
                  <Box
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "12px",
                      padding: "10px"
                    }}
                  >
                    {editData.properties.media.map((elm, idx) => (
                      <div
                        key={idx}
                        style={{
                          width: 120,
                          height: 120,
                          borderRadius: 10,
                          border: "1px solid #ddd",
                          overflow: "hidden",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#fafafa",
                          position: "relative",
                          cursor: "pointer"
                        }}
                      >
                        {/* CLOSE BUTTON — ALWAYS TAP-ABLE */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveMedia(elm);
                          }}
                          style={{
                            position: "absolute",
                            zIndex: 10,
                            top: 4,
                            right: 4,
                            width: 22,
                            height: 22,
                            borderRadius: "50%",
                            background: "rgba(0,0,0,0.6)",
                            color: "#fff",
                            border: "none",
                            fontSize: 14,
                            pointerEvents: "auto",   // <-- IMPORTANT
                            cursor: "pointer"
                          }}
                        >
                          ✕
                        </button>

                        {/* IMAGE */}
                        {elm.mimetype.startsWith("image/") && (
                          <img
                            src={`${baseUrl}/uploads/${elm.originalname}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover"
                            }}
                          />
                        )}

                        {/* VIDEO — allow button to receive tap */}
                        {elm.mimetype.startsWith("video/") && (
                          <video
                            src={`${baseUrl}/uploads/${elm.originalname}`}
                            loop
                            autoPlay
                            muted
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              pointerEvents: "none"   // <-- THIS FIXES THE TAP ISSUE
                            }}
                          />
                        )}
                      </div>
                    ))}
                  </Box>
                )}

              </Box>
            )}






          </DialogContent>
        </>}
        {editDataPolygon && <>
          <DialogTitle>Edit Room/Polygon Details</DialogTitle>
          <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            {/* {editDataPolygon && console.log(editDataPolygon)} */}
            <TextField label="Room Number" value={editDataPolygon?.properties?.number} name='number' onChange={handleChangePolygon} fullWidth size="small" />
            <TextField label="Room Name" value={editDataPolygon?.properties?.name} name='name' onChange={handleChangePolygon} fullWidth size="small" />


            {editDataPolygon?.layer?.id === "building-fills" && <>
              <TextField label="Fill Color" type='color' value={editDataPolygon?.properties?.fillColor} name='fillColor' onChange={handleChangePolygon} />
              <TextField label="Stroke Color" type='color' value={editDataPolygon?.properties?.strokeColor} name='strokeColor' onChange={handleChangePolygon} />

            </>}


            {uploading ? <CircularProgress /> : (!editDataPolygon?.properties?.filename && !editDataPolygon?.properties?.imageFile) ? <Button
              variant="outlined"
              component="label"
              size="small"
            >
              Upload Image
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleChangeFileRoom}
              />
            </Button> :
              <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                <img
                  src={editDataPolygon?.properties?.filename || editDataPolygon?.properties?.imageFile}
                  alt="Preview"
                  style={{ width: "100%", maxHeight: 150, objectFit: "contain", borderRadius: 8 }}
                />
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={() => {
                    setEditDataPolygon(prev => ({
                      ...prev,
                      properties: { ...prev.properties, filename: null }
                    }));
                  }}
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    minWidth: "auto",
                    padding: "2px 6px",
                    fontSize: "0.75rem",
                    borderRadius: 4
                  }}
                >
                  Remove
                </Button>
              </div>

            }

          </DialogContent>

        </>}


        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => {
            setOpenEdit(false)
            setCamera(false)
          }} color="secondary" variant="outlined">
            Cancel
          </Button>
          {saving ? <CircularProgress /> : <Button type="submit" variant="contained" color="primary" onClick={() => {
            handleSaveData()
          }}>
            Submit
          </Button>}
        </DialogActions>
      </Dialog>




    </div>
  );

}


export default GeoJsonGlobal